import React from 'react';

const MobileBottomNav = ({ activeTab, onTabChange, isSuperAdmin }) => {
  const tabs = [
    { id: 'overview', label: 'Home', icon: '🏠' },
    { id: 'donors', label: 'Donors', icon: '👥' },
    { id: 'requests', label: 'Requests', icon: '🩸' },
    { id: 'analytics', label: 'Analytics', icon: '📊' },
    { id: 'more', label: 'More', icon: '☰' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-40 safe-area-pb">
      <div className="flex justify-around items-center py-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-all ${
              activeTab === tab.id
                ? 'text-red-600 bg-red-50'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <span className="text-xl">{tab.icon}</span>
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileBottomNav;
